import loadScript from "load-script";
import querystring from "querystring";
import { BJ_AFREECA_URL, CLICK_LOG_URL, PROFILE_IMG_URL, STIMG_URL } from "./constants/config";
export var handleFetchErrors = function handleFetchErrors(response) {
  if (!response.ok) {
    return response.json().then(function (json) {
      return Promise.reject(json);
    });
  }

  return response;
};
/**
 * 언어셋 코드값
 * @param {*} lang
 */

export var getLanguageStr = function getLanguageStr(lang) {
  switch (lang) {
    case "en":
      return "en_US";

    case "ja":
      return "ja_JP";

    case "th":
      return "th_TH";

    case "zh":
      return "zh_CN";

    case "zh-TW":
      return "zh_TW";

    case "vi":
      return "vi_VN";

    default:
      return "ko_KR";
  }
};
export var isWebview = function () {
  var uagent = navigator.userAgent.toLocaleLowerCase();
  return uagent.indexOf("afreeca webview") > -1 || uagent.indexOf("afreeca up webview") > -1 ? true : false;
}();
export var callAU = function callAU(action) {
  window.szLogAction = action;
  loadScript("//analysis.onlive.vn/_au.js", function () {
    window.szLogAction = "";
  });
};
/**
 * CLICK로그
 */

export var setClickLog = function setClickLog(code_type, sendData, szSysType) {
  if (typeof szSysType == "undefined" || szSysType == "") {
    szSysType = "web";
  }

  var data = {
    sztype: "CLICK",
    code_type: code_type,
    send_data: querystring.stringify(sendData),
    sys_type: szSysType
  }; //로딩

  return fetch(CLICK_LOG_URL, {
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    body: querystring.stringify(data),
    credentials: "include"
  }).then(function () {}).catch(function () {});
};
export var setClickLogFn = function setClickLogFn(code_type, sendData) {
  return function () {
    setClickLog(code_type, sendData);
  };
};
/**
 * 방송국 URL
 * @param {*} user_id
 */

export var getStationUrl = function getStationUrl(user_id) {
  return BJ_AFREECA_URL + "/" + user_id;
};
/**
 * 프로필 이미지 만들기
 * @param user_id
 */

export var makeProfileUrl = function makeProfileUrl(user_id, errorCheck) {
  if (errorCheck === void 0) {
    errorCheck = false;
  }

  if (errorCheck) {
    return PROFILE_IMG_URL + "/LOGO/" + user_id.substr(0, 2) + "/" + user_id + "/" + user_id + ".jpg";
  }

  return STIMG_URL + "/LOGO/" + user_id.substr(0, 2) + "/" + user_id + "/m/" + user_id + ".webp";
};